import type { FC } from 'react'

import BallotSurvey from 'app/components/Ballot/Survey'
import { Modal } from 'app/components/design-system-components'

interface IBallotSurveyModalProps {
  ballotSurveyFormRef: any
  toggleBallotSurveyModal: () => void
  submitBallotSurveyModal: () => void
  applyButtonClicked: () => void
  teamSlug?: string
}

const BallotSurveyModal: FC<IBallotSurveyModalProps> = ({
  ballotSurveyFormRef,
  toggleBallotSurveyModal,
  submitBallotSurveyModal,
  applyButtonClicked,
  teamSlug = '',
}) => {
  return (
    <Modal
      toggleModal={() => toggleBallotSurveyModal()}
      modalHeading={'Survey'}
      modalBody={
        <BallotSurvey formRef={ballotSurveyFormRef} teamSlug={teamSlug} />
      }
      primaryLabel={'Submit & Continue'}
      primaryAction={() => submitBallotSurveyModal()}
      secondaryLabel={'Cancel'}
      secondaryAction={() => toggleBallotSurveyModal()}
      primaryButtonLoading={!!applyButtonClicked}
      modalFooter={undefined}
    />
  )
}

export default BallotSurveyModal
